export const formatTimeHours = (format: string, value: string) => {
  if (value && value.length == 4 && !value.includes(":")) {

    switch (format) {
      case 'Hh:m0':
        return value.slice(0, 2) + ':' + value.slice(2);
    }
  }
  return value;
}

function validateTime(value: string[]): string {
  if (value.length == 4) {
    if (value[0] == "2" && ["4", "5"].includes(value[1])) {
      value.pop();
      value.unshift("0");
    }

    if (value[0] == "2" && parseInt(value[2]) >= 6) {
      value.pop();
      value.unshift("0");
    }
  }
  return `${value.slice(0, 2).join('')}:${value.slice(2).join('')}`;
}
